<template>
  <button
    v-on="$listeners"
    data-testid="addButton"
    class="btn btn-outline-primary d-flex align-items-center"
    v-shortkey="addShortKey"
    @shortkey="handleShortkey"
    type="button"
  >
    <icon class="mr-2" :icon="icon" />
    <span>{{ text }}</span>
  </button>
</template>

<script>
import { altKey } from "@/modules/helpers";
import Icon from "./Icon.vue";
export default {
  components: { Icon },
  name: "AddBtn",
  inheritAttrs: true,
  props: {
    text: {
      type: String,
      default: "Add"
    },
    icon: {
      type: String,
      default: "plus"
    },
    shortkey: {
      type: String,
      default: "a"
    },
    disableShortKey: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    addShortKey() {
      if (this.disableShortKey) {
        return null;
      }
      return altKey(this.shortkey);
    }
  },
  methods: {
    handleShortkey() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped></style>
